import { Component } from '@angular/core';

@Component({
  selector: 'app-cer-edit-page',
  templateUrl: './cer-edit-page.component.html',
  styleUrls: ['./cer-edit-page.component.scss'],
})
export class CerEditPageComponent {}
